import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FieldSupervisor } from '../models/fsupervisor.model';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { MsalService } from '@azure/msal-angular';
import { ThemeService } from '../services/theme.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  
    logoLightUrl: string;
    portalTitle: string;

    constructor(private authService: AuthService,
      private msalService: MsalService,
        private router: Router,
        private globalService: GlobalService,
        private themeService: ThemeService) { }

    ngOnInit() {
      if (!this.authService.authenticated) {
        this.router.navigate(['auth']);
      }
      
      this.themeService.logo$.subscribe(logo => {
        this.logoLightUrl = logo.light;
        this.portalTitle = logo.portalTitle;
        });

    }

    signOut(){
      this.msalService.logout();
      this.router.navigate(['auth']);
    }

    getHeaderRowClass(): string {

      if(this.globalService == null || this.globalService.supervisor == null){
        return 'tot-header-row';
      }

      if (this.globalService.supervisor.CompanyId === 1) {
        return 'tot-header-row';
      } else if (this.globalService.supervisor.CompanyId === 2) {
        return 'teach-header-row';
      }
      return 'teach-header-row';
    }
}
